<template>
  <div>
    <v-dialog v-model="showStoreDialog" persistent width="800">
      <v-toolbar>
        <v-icon large color="black">store</v-icon>
        <v-toolbar-title>ร้านค้าที่ร่วมแคมเปญ</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn @click="disableDialogAndResetStoreshow" icon>
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-toolbar dense flat>
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  style="padding: 0"
                ></v-text-field>
              </v-toolbar>
            </v-flex>
          </v-layout>
          <br />
          <div
            class="scroll-panel"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
            <v-data-table
              :search="search"
              :items="data"
              :headers="header"
              hide-actions
              hide-headers
            >
              <template v-slot:items="props">
                <td class="text-xs-left">
                  <v-icon small color="gray">storefront</v-icon>
                  {{ props.item.store_name_th }}
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: ["showStoreDialog", "storeProps", "storeList"],
  data() {
    return {
      page: 1,
      data: [],
      busy: false,
      search: "",
      header: [
        {
          text: false,
          align: "left",
          value: "store_name_th",
          sortable: false,
        },
      ],
    };
  },
  watch: {
    showStoreDialog() {
      if (this.showStoreDialog == true) {
        this.data = [];
        this.busy = false;
        this.page = 1;
        this.loadMore();
      }
    },
  },
  computed: {
    showStoreLsdist() {
      let arr = [];
      let arr2 = [];
      for (let i = 0; i < this.storeList.length; i++) {
        for (let j = 0; j < this.storeProps.length; j++) {
          if (this.storeList[i].store_id === this.storeProps[j]) {
            arr.push(this.storeList[i]);
          }
        }
      }
      for (let k = 0; k < arr.length; k++) {
        arr2.push(arr[k]);
      }
      return arr2;
    },
  },
  methods: {
    loadMore() {
      if (this.busy) return;
      this.busy = true;
      let page = this.page++;
      let storeIdList = this.storeProps.slice(10 * (page - 1), 10 * page);
      let list = [];
      for (let i = 0; i < this.storeList.length; i++) {
        for (let j = 0; j < storeIdList.length; j++) {
          if (this.storeList[i].store_id === storeIdList[j]) {
            list.push(this.storeList[i]);
          }
        }
      }

      this.data = [...this.data, ...list];
      if (this.data.length < this.storeProps.length) {
        this.busy = false;
      }
    },
    disableDialogAndResetStoreshow() {
      this.$emit("disableShowStoreDialog");
    },
  },
};
</script>
<style scoped>
.showListStore {
  width: 100%;
}
.scroll-panel {
  width: 100%;
  height: 300px;
  overflow: auto;
}
</style>
